var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7481 5.91C16.6881 5.9 16.6181 5.9 16.5581 5.91C15.1781 5.86 14.0781 4.73 14.0781 3.33C14.0781 1.9 15.2281 0.75 16.6581 0.75C18.0881 0.75 19.2381 1.91 19.2381 3.33C19.2281 4.73 18.1281 5.86 16.7481 5.91Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7175 13.1902C17.0875 13.4202 18.5975 13.1802 19.6575 12.4702C21.0675 11.5302 21.0675 9.9902 19.6575 9.0502C18.5875 8.34016 17.0575 8.10016 15.6875 8.34016",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71852 5.91C4.77852 5.9 4.84852 5.9 4.90852 5.91C6.28852 5.86 7.38852 4.73 7.38852 3.33C7.38852 1.9 6.23852 0.75 4.80852 0.75C3.37852 0.75 2.22852 1.91 2.22852 3.33C2.23852 4.73 3.33852 5.86 4.71852 5.91Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7475 13.1902C4.3775 13.4202 2.8675 13.1802 1.8075 12.4702C0.3975 11.5302 0.3975 9.9902 1.8075 9.0502C2.8775 8.34016 4.4075 8.10016 5.7775 8.34016",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7481 13.3807C10.6881 13.3707 10.6181 13.3707 10.5581 13.3807C9.17814 13.3307 8.07812 12.2007 8.07812 10.8007C8.07812 9.37067 9.22815 8.2207 10.6581 8.2207C12.0881 8.2207 13.2381 9.38067 13.2381 10.8007C13.2281 12.2007 12.1281 13.3407 10.7481 13.3807Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8368 16.5294C6.4268 17.4694 6.4268 19.0094 7.8368 19.9494C9.43679 21.0194 12.0568 21.0194 13.6568 19.9494C15.0668 19.0094 15.0668 17.4694 13.6568 16.5294C12.0668 15.4694 9.43679 15.4694 7.8368 16.5294Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeader);
export default __webpack_public_path__ + "static/media/leader.e36ea1d6ffb4aa0f3b6460ce9a339e0b.svg";
export { ForwardRef as ReactComponent };